var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('navigation-button',{staticClass:"customer-read-edit",attrs:{"icon":"pen","label":"Editar cliente","href":_vm.href}})}
var staticRenderFns = []

export { render, staticRenderFns }